import { i18n } from '@/i18n/index'

/** 攻击类型对后端的映射 */
export enum AttackType {
  /** 木马病毒 */
  trojanHorse = 1,
  /** 挖矿攻击 */
  miningAttack = 2,
  /** 勒索病毒 */
  ransomware = 3,
  /** 违规内容 */
  offendingContent = 4,
  /** 风险软件 */
  riskSoftware = 5,
  /** 高级威胁 */
  advancedThreat = 6,
  /** 钓鱼攻击 */
  phishingAttack = 7,
  /** 扫描探测 */
  scanDetection = 8,
  /** 可疑流量 */
  suspiciousTraffic = 9,
  /** 内网渗透（前端自定义） */
  intranetSeep = 91,
  /** 未知 */
  unknown = 10
}

/** 攻击类型色号 */
export enum AttackTypeColor {
  /** 木马病毒 */
  trojanHorse = '#FFC169',
  /** 挖矿攻击 */
  miningAttack = '#FD8C03',
  /** 勒索病毒 */
  ransomware = '#E65656',
  /** 违规内容 */
  offendingContent = '#FE9208',
  /** 风险软件 */
  riskSoftware = '#FF9C6E',
  /** 高级威胁 */
  advancedThreat = '#5DDBD3',
  /** 钓鱼攻击 */
  phishingAttack = '#84A5FE',
  /** 扫描探测 */
  scanDetection = '#cc8fd3',
  /** 可疑流量 */
  suspiciousTraffic = '#69C0FF',
  /** 内网渗透 */
  intranetSeep = '#FE85C0',
  /** 未知 */
  unknown = '#D4F262'
}

/** 下拉等展示顺序（与历史 AttackTypeTitle 一致，不含 unknown） */
const ATTACK_TYPE_KEYS_IN_ORDER: (keyof typeof AttackType)[] = [
  'trojanHorse',
  'miningAttack',
  'ransomware',
  'offendingContent',
  'riskSoftware',
  'advancedThreat',
  'phishingAttack',
  'scanDetection',
  'suspiciousTraffic',
  'intranetSeep',
]

export interface AttackTypeOption {
  label: string
  value: number | undefined
}

/** 按数值反查枚举名，再取 `attackType.<name>` 文案 */
export function getAttackTypeLabel (value: AttackType | number | string | undefined | null): string {
  if (value === undefined || value === null || value === '') {
    return ''
  }
  const num = typeof value === 'string' ? parseInt(value, 10) : Number(value)
  if (Number.isNaN(num)) {
    return i18n.global.t('attackType.unknown')
  }
  const nameKey = AttackType[num as AttackType] as keyof typeof AttackType | undefined
  if (!nameKey || typeof nameKey !== 'string') {
    return i18n.global.t('attackType.unknown')
  }
  return i18n.global.t(`attackType.${nameKey}`)
}

/** 含「全部」；各选项 label 随当前语言变化，请在组件内随 locale 重算或每次打开下拉时调用 */
export function getAttackTypeOptions (): AttackTypeOption[] {
  const t = i18n.global.t
  return [
    { label: t('attackType.all'), value: undefined },
    ...ATTACK_TYPE_KEYS_IN_ORDER.map((k) => ({
      label: t(`attackType.${k}`),
      value: AttackType[k] as number,
    })),
  ]
}

/** 不含内网渗透（91），与历史 FALL_TYPE_OPTIONS 一致 */
export function getFallTypeOptions (): AttackTypeOption[] {
  return getAttackTypeOptions().filter((v) => v.value !== AttackType.intranetSeep)
}
